import { Component, Input, ViewContainerRef } from '@angular/core';
import { RetailItemStoreService } from './retail-item.store.service';
import { filter, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { RetailItemSale } from '../../models/retail-item-sale';
import { EditRetailItemComponent } from './edit-retail-item/edit-retail-item.component';
import {
  RETAIL_ITEM_PERSISTANCE_SERVICE,
  RetailItemSearchComponent
} from './retail-item-search/retail-item-search.component';
import { ItemsTableComponent } from './items-table/items-table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgIf, AsyncPipe } from '@angular/common';
import { RetailItemPersistenceService } from './retail-item-search/retail-item-persistence.service';

@Component({
  selector: 'app-retail-item-list',
  templateUrl: './retail-item-list.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgxSkeletonLoaderModule,
    ItemsTableComponent,
    RetailItemSearchComponent,
    AsyncPipe
  ],
  providers: [
    {
      provide: RETAIL_ITEM_PERSISTANCE_SERVICE,
      useClass: RetailItemPersistenceService
    }
  ]
})
export class RetailItemListComponent {
  @Input() parentType = 'sales invoice';
  @Input() preview = false;
  @Input() showGridButton = false;

  @Input() set currency(currency: string) {
    this.retailItemListStore.setCurrency(currency);
  }

  @Input() set currencyRate(rate: number) {
    this.retailItemListStore.setCurrencyRate(rate);
  }

  @Input() set docketId(docketID: number) {
    if (docketID === null) {
      return;
    }
    this.retailItemListStore.setId(docketID);
  }

  @Input() canEdit = true;
  @Input() canAdd = true;
  @Input() eposMode = false;

  itemsLoading$ = this.retailItemListStore.loading$;
  items$ = this.retailItemListStore.items$;
  currency$ = this.retailItemListStore.currency$;
  currencyRate$ = this.retailItemListStore.currencyRate$;

  constructor(
    private retailItemListStore: RetailItemStoreService,
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef
  ) {}

  add() {
    this.retailItemListStore.addItem({
      retail_product_id: 2,
      quantity: 2,
      unit_price: 300,
      tax_rate: 0.2
    });
  }

  delete(id: number) {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Delete Item',
          message: 'Are you sure you want to delete this item?',
          type: 'delete'
        }
      })
      .afterClosed()
      .pipe(
        take(1),
        filter((result) => result === true)
      )
      .subscribe(() => this.retailItemListStore.delete(id));
  }

  edit(item: RetailItemSale) {
    this.dialog.open(EditRetailItemComponent, {
      data: item,
      viewContainerRef: this.viewContainerRef
    });
  }
}
